export { cartStore } from './store';
import { cartStore } from './store';
// Backwards-compatible singleton accessor
export const getCartMachine = ()=>cartStore;
